import Axios from 'axios'

const { REACT_APP_ASSIGNATION_API = 'https://develop-api-assignation.egg.live' } = process.env

export const ApiAssignation = Axios.create({
    baseURL: REACT_APP_ASSIGNATION_API,
})

export const fetchExpertMentors = () =>
    ApiAssignation.get<API<ExpertMentorsDTO>>('/assign/assignation/mentor_status').then(
        ({ data }) => data
    )

// Interfaces
type API<T> = T

export type MentorStatusDTO = keyof ExpertMentorsDTO['mentors']

export type ExpertMentorsDTO = {
    mentors: {
        availables: MentorsDTO[]
        busy: MentorsDTO[]
        unavailable: MentorsDTO[]
    }
}

export type MentorsDTO = {
    profileId: string
    status: 'available' | 'busy' | 'unavailable'
    teamNumber?: number
}
